import * as _ from 'lodash';
import type { VoidFunctionComponent } from 'react';

import { useBillingTerms } from '../../../../hooks/api/billing/useBillingTerms';
import Card from '../../../generic/Card/Card';
import List from '../../../generic/List';
import ListRowLoading from '../../../generic/List/ListRowLoading';
import Text from '../../../generic/Text';

import AddBillingTermForm from './AddBillingTermForm';
import BillingTermRow from './BillingTermRow';

import styles from './BillingTermCard.module.less';

const BillingTermCard: VoidFunctionComponent = () => {
  const { data: billingTerms = [], isLoading } = useBillingTerms();

  return (
    <Card isFullWidth padding="medium">
      <Card.Header>Manage Billing Terms</Card.Header>
      <Card.Content>
        <div className={styles.billingTermsCard}>
          <Text.H4>Current Billing Terms</Text.H4>
          <List.Body>
            {isLoading && _.times(billingTerms.length || 1, () => (<ListRowLoading />))}
            {!isLoading &&
            billingTerms.map((billingTerm) => (
              <BillingTermRow key={billingTerm.id} billingTerm={billingTerm} />
            ))}
          </List.Body>
          <AddBillingTermForm />
        </div>
      </Card.Content>
    </Card>
  );
};

export default BillingTermCard;
